import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Snowflake } from "lucide-react";

const KEY = "easyice_cookie_consent";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (err) {
      console.warn("CookieBanner read failed:", err);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted_" + Date.now()); } catch (err) { console.warn("CookieBanner write failed:", err); }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50" data-testid="cookie-banner">
      <div className="bg-[#032B44] text-white rounded-2xl shadow-2xl p-5 border border-sky-800">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-white/10 grid place-items-center shrink-0">
            <Snowflake className="w-4 h-4" />
          </div>
          <div className="flex-1">
            <p className="font-heading text-base font-medium mb-1">Usiamo solo cookie tecnici</p>
            <p className="text-xs text-sky-100/90 leading-relaxed">
              Necessari per farti accedere e ricordare il tuo carrello. Nessun tracciamento, nessun
              cookie di marketing.{" "}
              <Link to="/cookie-policy" className="underline hover:text-white" data-testid="cookie-banner-link">
                Leggi di più
              </Link>
              .
            </p>
          </div>
        </div>
        <button
          onClick={accept}
          className="mt-4 w-full h-10 rounded-lg bg-white text-[#032B44] font-medium text-sm hover:bg-sky-50 transition-colors"
          data-testid="cookie-banner-accept"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
